import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/icon-o-attention.svg'


const _withScopeId = n => (_pushScopeId("data-v-bae9ce50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"100%"} }
const _hoisted_2 = {
  class: "regional",
  style: {"height":"100%"}
}
const _hoisted_3 = { style: {"position":"relative","display":"flex"} }
const _hoisted_4 = {
  class: "from",
  style: {"margin":"0","width":"50%"}
}
const _hoisted_5 = {
  key: 0,
  class: "from",
  style: {"margin":"0 0 0 40px","width":"50%"}
}
const _hoisted_6 = {
  class: "btnBox",
  style: {"display":"block","padding":"0","width":"75px","margin-left":"40px"}
}
const _hoisted_7 = {
  class: "btnBox",
  style: {"background-color":"transparent","justify-content":"start"}
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { style: {"display":"flex","flex-wrap":"wrap"} }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "operatingBtn pointer" }
const _hoisted_13 = {
  class: "operatingBtn",
  style: {"padding":"4px 0"}
}
const _hoisted_14 = {
  class: "operatingBtn",
  style: {"padding":"4px 0"}
}
const _hoisted_15 = {
  class: "operatingBtn",
  style: {"padding":"4px 0"}
}
const _hoisted_16 = { style: {"margin-top":"20px","display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_17 = { style: {"height":"100%","box-sizing":"border-box","position":"relative"} }
const _hoisted_18 = { class: "userFrom" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "from" }
const _hoisted_21 = { class: "from" }
const _hoisted_22 = { class: "from" }
const _hoisted_23 = {
  key: 0,
  class: "from"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"margin-left":"2px","transform":"translateY(2px)"},
  src: _imports_0
}, null, -1))
const _hoisted_25 = { class: "from" }
const _hoisted_26 = { class: "from" }
const _hoisted_27 = {
  key: 1,
  class: "systemListBox"
}
const _hoisted_28 = { class: "listBox" }
const _hoisted_29 = { style: {"display":"flex","gap":"10px","flex-wrap":"wrap"} }
const _hoisted_30 = {
  class: "systemBox",
  style: {"padding":"5px 10px"}
}
const _hoisted_31 = { class: "btnBox" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  key: 1,
  class: "btn line pointer"
}
const _hoisted_34 = {
  key: 0,
  style: {"position":"fixed","top":"0","left":"0","right":"0","bottom":"0","z-index":"9999","width":"100vw","height":"100vh"}
}

import { ref,reactive,computed } from 'vue'
import { ElMessage,ElMessageBox } from 'element-plus';
import { selectUser, exportUser, findRoleListByUserId, addUser,addSystemUser, delUser, updateUser,addSystemAndRole,delSystemAndRole,getCompanyList,getUserById,getUserTypeDown,unlock } from './userApi'
import { findSysSystemList,simulateLogin, simulateLoginStatus } from '../loginApi'
import ResetPasswords from './ResetPasswords.vue'
import { passwordVerify } from '@/utils/index'
// 平台权限
import PlatformPer from './PlatformPer.vue'
// import dayjs from 'dayjs'
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
type SystemType = {
  systemId: string
  systemName: string
  sysRoleList: RoleType[]
}
type RoleType = {
  roleName: string
  id: string
}
type UserTableType = {
  systemId: string
  roleId: string
  userSystemRoleId?: string|null
  options: RoleType[],
  systemName?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'userManagement',
  emits: ['setLine', 'delLine'],
  setup(__props, { emit: emits }) {

const { t } = useI18n();

const store = useStore();
const getLanguageValue = computed(() => store.getters.getLanguageValue);
const userInfo = computed(() => store.getters.getUserInfo);
// CS以上（不包含CS）
const isAdmin = computed(() => Number(store.getters.getUserInfo.level) <= 2);
function init() {
  getList()
  getSystemList()
  // getFindRoleList()
  // getCompanyListFn()
}
const addShow = ref<false | 'add' | 'editSysTemAndRole' | 'edit' | 'details'>(false)
const btnLoading = ref(false)
// 获取表格数据
const tableData = ref<[]>([

])
const search = reactive({
  account: '',
  isPolarUser: '',
  pageNo: 1,
  pageSize: 10,
  total: 0
})
let loading = ref(true)
function getList() {
  loading.value = true
  selectUser(search).then(res => {
    // tableData.value = [{sysSystemRoleVOList:[],loginName:9999}]
    if(res.data.records) {
      tableData.value = res.data.records.map((e:any) => {
        e.showMore = false
        return e
      })
    }
    search.total = res.data.total 
    // setAxLanguage(tableData.value,['nickName'])
  }).finally(()=>loading.value = false)
}
function setAxLanguage(list: [], arr: string[]) {
  arr.forEach((e: string) => {
    list.forEach((e2: any) => {
      if (getLanguageValue.value == 'zh-hk') {
        e2[e] = e2[e + 'Tc'];
      } else if (getLanguageValue.value == 'en') {
        e2[e] = e2[e + 'En'];
      } else {
        e2[e] = e2[e + 'Sc'];
      }
    });
  });
  return list;
}
// 获取角色列表
const roleList = ref<SystemType[]>([])
function getFindRoleList() {
  findRoleListByUserId().then(res => {
    roleList.value = res.data.filter((e: any) => {
      e.id = e.systemId
      e.sysRoleList.forEach((e2: any) => {
        e2.systemName = e2.roleName
      })
      return e.sysRoleList
    })
  })
}
// 表格/删除新增列
const userTable = ref<UserTableType[]>([])
function handleAddRole() {
  userTable.value.push(
    {
      systemId: '',
      roleId: '',
      options: [],
    }
  )
}
function handleDelRole(item: any, i: number) {
  if (item.userSystemRoleId) {
    ElMessageBox.confirm(
      t('login.deleteMsg'),
      t('login.delete'),
      {
        confirmButtonText: t('login.confirm'),
        cancelButtonText: t('login.cancel'),
        type: 'warning',
      }
    ).then(() => {
      const obj = {
        loginName: form.value.loginName,
        userSystemRoleId: item.userSystemRoleId 
      }
      delSystemAndRole(obj).then(res => {
        userTable.value.splice(i, 1)
        ElMessage({ message: res.resultMessage, type: 'success' })
        getList()
      })
    }).catch(() => {})
  } else {
    userTable.value.splice(i, 1)
  }
}
function changeSystem(item: any) {
  roleList.value.forEach((e, i) => {
    if (e.systemId == item.systemId) {
      item.options = roleList.value[i].sysRoleList
    }
  })
  item.roleId = ''
}
const props = {
  label: 'roleName',
  value: 'id',
  children: 'clientList',
  emitPath: false
}

// 重置密碼
const visible = ref(false)
const userId = ref('')
const resetPass = (id:string) => {
  visible.value = true
  userId.value = id
}
// 詳情
const formLoading = ref(false)
const handleDetails = (id: string) => {
  addShow.value = 'details'
  formLoading.value = true
  emits('setLine','add',[{ name: t('login.details'), callback: function(){addShow.value = false}}])
  getUserById({id}).then(res => {
    userTable.value = res.data.systemNames ? res.data.systemNames.split('，'): []
    form.value = res.data
    formLoading.value = false
  })
}
// 導出
const exportLoading = ref(false)
const handleExport = () => {
  if(exportLoading.value) return 
  exportLoading.value = true
  exportUser(search).then(res => {
    if (res.type === 'application/json') { 
      return ElMessage.error(t('login.exportError'))
    }
    // 接口返回数据为二进制流文件
    const content = res;
    // 根据接口返回的二进制流创建Blob类文件对象
    const blob = new Blob([content]);
    // 使用原生js创建一个a元素标签
    const elink = document.createElement("a");
    // 获取方法形参中的filename文件名
    elink.download = t('login.subscriberData')+'.xlsx';
    // 通过原生js让a标签的display属性值为none，从而隐藏a标签
    elink.style.display = "none";
    // 通过blob创建下载的链接
    const href = URL.createObjectURL(blob);
    // 通过原生js让a标签的href属性为创建好的下载链接
    elink.href = URL.createObjectURL(blob);
    // 在html中添加a标签
    document.body.appendChild(elink);
    // 给a标签调用点击事件，开始下载
    elink.click();
    // 释放掉blob对象
    URL.revokeObjectURL(elink.href);
    // 在html中移除此a标签
    document.body.removeChild(elink);
  }).finally(()=>exportLoading.value = false)
}

// 新增/修改用户
const form = ref<any>({})
const editId = ref<string>('')
// 点击新增按钮
function handleAddOpen() {
  addShow.value = 'add'
  emits('setLine','add',[{ name: t('login.add'), callback: function(){addShow.value = false}}])
  editId.value = ''
  form.value = {}
  userTable.value = []
  handleAddRole()
}
// 点击编辑按钮
function handleEditOpen(item: any) {
  addShow.value = 'edit'
  emits('setLine','add',[{ name: t('login.subscriberData'), callback: function(){addShow.value = false}}])
  editId.value = item.id
}
function handleEditSysTemAndRole(item: any) {
  addShow.value = 'editSysTemAndRole'
  emits('setLine','add',[{ name: t('login.configurePermissions'), callback: function(){addShow.value = false}}])
  form.loginName = item.loginName
  editId.value = item.id
  userTable.value = item.sysSystemRoleVOList?JSON.parse(JSON.stringify(item.sysSystemRoleVOList)):[]
  const time = setInterval(() => {
    if (roleList.value.length) {
      clearInterval(time)
      userTable.value.forEach(e => {
        roleList.value.forEach(e2 => {
          if (e.systemId === e2.systemId) {
            e.options = e2.sysRoleList
          }
        })
      })
    }
  },100)
}
// 提交验证
function handleSumbit() {
  const emailReg = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z]{2,4})+$/;
  if (addShow.value != 'editSysTemAndRole') {
    if (!form.value.account) {
      return ElMessage.error(t('login.input') + t('login.account').toLowerCase())
    } else if (!form.value.nickName) {
      return ElMessage.error(t('login.input') + t('login.userName').toLowerCase());
    } else if (!form.value.userName) {
      return ElMessage.error(t('login.input') + t('login.nickName').toLowerCase());
    } else if (!form.value.userPassword) {
      return ElMessage.error(t('login.input') + t('login.password').toLowerCase());
    } else if (!form.value.userTypeId) {
      return ElMessage.error(t('login.select') + t('login.userType').toLowerCase());
    } else if (form.value.email && !emailReg.test(form.value.email)) {
      return ElMessage.error(t('login.input') + t('login.correct').toLowerCase() + t('login.userEmail').toLowerCase());
    }
  }

  if (passwordVerify(form.value.userPassword)) return ElMessage.error(passwordVerify(form.value.userPassword))
  // 系统/角色ID
  let roleIds:string[] = []
  let systemIds: string[] = []
  let sysUserSystemList: {systemId:string,roleId:string,id:string|null}[] = []
  userTable.value.forEach(e2 => {
    if (e2.roleId) roleIds.push(e2.roleId)
    if (e2.systemId) systemIds.push(e2.systemId)
    sysUserSystemList.push({systemId:e2.systemId,roleId:e2.roleId,id:e2.userSystemRoleId as string})
  })
  // if (userTable.value.length !== systemIds.length && addShow.value != 'edit') {
  //   return ElMessage.error(t('login.select') + t('login.interactedSystem').toLowerCase());
  // } else if (userTable.value.length !== roleIds.length && addShow.value != 'edit') {
  //   return ElMessage.error(t('login.select') + t('login.associatedRole').toLowerCase());
  // } 
  const obj = {
    ...form.value,
    id: editId.value
  }
  btnLoading.value = true
  if (addShow.value == 'edit') {
    editUserFn(obj)
  } else if (addShow.value == 'editSysTemAndRole') {
    editUserSysAndRoleFn(sysUserSystemList)
  } else {
    addUserFn(form.value, sysUserSystemList)
  }
}
// 用戶類型
const userTypeList = ref<any>({})
getUserTypeDown().then(res=>{
  userTypeList.value = res.data
})
// 新增用户
function addUserFn(params: any, data: any) {
  const obj = {
    ...params,
    sysUserSystemRoleList: data
  }
  addSystemUser(obj).then(res => {
    ElMessage({ message: res.resultMessage, type: 'success' })
    addShow.value = false
    emits('delLine', 1)
    getList()
  }).finally(()=>btnLoading.value = false)
}
// 修改用户信息
function editUserSysAndRoleFn(data: any) {
  addSystemAndRole({loginName:form.value.loginName,userId: editId.value},data).then(res => {
    ElMessage({ message: res.resultMessage, type: 'success' })
    addShow.value = false
    emits('delLine', 1)
    getList()
  }).finally(()=>btnLoading.value = false)
}
// 修改用户系统和角色
function editUserFn(params: any) {
  updateUser(params).then(res => {
    ElMessage({ message: res.resultMessage, type: 'success' })
    addShow.value = false
    emits('delLine', 1)
    getList()
  }).finally(()=>btnLoading.value = false)
}

// 表格选中的值
const tableRef = ref(null)
const tableCheck = ref<string[]>([])
function handleSelectionChange(val:any) {
  tableCheck.value = val.map((e:any)=>{return e.id})
}
// 删除用户
function handleDel(id?: string) {
  if (id) {
    delUser([id]).then(res => {
      ElMessage({ message: res.resultMessage, type: 'success' })
      getList()
    })
  } else {
    if (!tableCheck.value.length) return ElMessage.error(t('login.leastOne').toLowerCase());
    ElMessageBox.confirm(
      t('login.deleteMsg'),
      t('login.delete'),
      {
        confirmButtonText: t('login.confirm'),
        cancelButtonText: t('login.cancel'),
        type: 'warning',
      }
    ).then(() => {
      delUser(tableCheck.value).then(res => {
        ElMessage({ message: res.resultMessage, type: 'success' })
        getList()
      })
    }).catch(() => {})
  }
}
// 
const companyList = ref<{ companyName: string, code: string }[]>([])

function getCompanyListFn() {
  // getCompanyList().then((res:any) => {
  //   companyList.value = res.data
  // })
}
// 获取系统列表
const systemList = ref<any[]>([])
const getSystemList = () => {
  findSysSystemList().then((res: any) => { 
    systemList.value = res.data
  })
}

// 关联平台
const platFormOpen = ref(false)
const handlePlatformOpen = (row:any) => {
  userId.value = row.id
  platFormOpen.value = true
}
// 解锁账号
const handleUnlock = (row:any) => {
  ElMessageBox.confirm(
    t('login.confirmUnlock'),
    t('login.Unlock'),
    {
      confirmButtonText: t('login.confirm'),
      cancelButtonText: t('login.cancel'),
      type: 'warning',
    }
  ).then(() => {
    unlock({userId: row.id}).then(res => {
      ElMessage({ message: res.resultMessage, type: 'success' })
    })
  })
}
// 模拟登录
const simulateLoading = ref(false)
const simulateLoginFn = (account: string) => {
  simulateLoading.value = true
  simulateLogin(account).then((res) => {
    localStorage.setItem('singlelogin-simulateToken',res.data.token)
    window.location.reload()
  }).finally(()=>simulateLoading.value = false)
}
const handleSimulateLogin = (row: { account: string }) => { 
  simulateLoading.value = true
  simulateLoginStatus(row.account).then(res => {
    if (res.data) {
      ElMessageBox.confirm(
        t('login.simulating',{ name: res.data }),
        t('login.simulateLogin'),
        {
          confirmButtonText: t('login.continueSimulate'),
          cancelButtonText: t('login.cancel'),
          type: 'warning',
          buttonSize: 'default'
        }
      ).then(() => {
        simulateLoginFn(row.account)
      })
    } else {
      simulateLoginFn(row.account)
    }
  }).finally(()=>simulateLoading.value = false)
}
const moreList = () => {
  return [
    
  ]
}

init()

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_Minus = _resolveComponent("Minus")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_input, {
              modelValue: search.account,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.account) = $event)),
              class: "w-50 m-2 inputbox",
              size: "large",
              placeholder: _ctx.$t('login.input')+_ctx.$t('login.account')+'/'+_ctx.$t('login.userName'),
              type: "text",
              onKeydown: _withKeys(getList, ["enter"]),
              style: {"height":"48px"}
            }, null, 8, ["modelValue", "placeholder", "onKeydown"])
          ]),
          (userInfo.value.userType !== 'normal' && userInfo.value.userType !== 'customer')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_el_select, {
                  modelValue: search.isPolarUser,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search.isPolarUser) = $event)),
                  class: "w-50 m-2 inputbox",
                  size: "large",
                  placeholder: _ctx.$t('login.bluePlatformUsers'),
                  type: "text",
                  clearable: "",
                  style: {"height":"48px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: _ctx.$t('login.yes'),
                      value: '1'
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _ctx.$t('login.no'),
                      value: '0'
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "btn line pointer",
              onClick: getList
            }, _toDisplayString(_ctx.$t('login.inquire')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (userInfo.value.userType !== 'normal' && userInfo.value.userType !== 'customer')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "btn line pointer",
                onClick: handleAddOpen
              }, _toDisplayString(_ctx.$t('login.add')), 1))
            : _createCommentVNode("", true),
          (userInfo.value.userType !== 'normal' && userInfo.value.userType !== 'customer')
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "btn line pointer",
                onClick: handleExport
              }, [
                _withDirectives(_createVNode(_component_el_icon, { class: "loadingIcon" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Loading)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, exportLoading.value]
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('login.export')), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: tableData.value,
          style: {"width":"100%"},
          size: "large",
          height: "100%",
          "max-height": userInfo.value.userType !== 'normal' && userInfo.value.userType !== 'customer' ? 'calc(100% - 182px)' : 'calc(100% - 144px)',
          ref_key: "tableRef",
          ref: tableRef,
          onSelectionChange: handleSelectionChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "account",
              label: _ctx.$t('login.account'),
              width: "130"
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "nickName",
              label: _ctx.$t('login.userName'),
              width: "120"
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "userType",
              label: _ctx.$t('login.userType'),
              width: "100"
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "systemRole",
              label: _ctx.$t('login.relevanceSystem'),
              minWidth: "190"
            }, {
              default: _withCtx((scope) => [
                (scope.row.systemNames)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.showMore?scope.row.systemNames.split('，'):scope.row.systemNames.split('，').slice(0,3), (item, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.id,
                          class: "systemBox"
                        }, _toDisplayString(item), 1))
                      }), 128)),
                      _withDirectives(_createVNode(_component_el_icon, {
                        class: "systemBox",
                        style: {"height":"22px","cursor":"pointer"},
                        onClick: ($event: any) => (scope.row.showMore=true)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Plus)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]), [
                        [_vShow, !scope.row.showMore && scope.row.systemNames.split('，').length>3]
                      ]),
                      _withDirectives(_createVNode(_component_el_icon, {
                        class: "systemBox",
                        style: {"height":"22px","cursor":"pointer"},
                        onClick: ($event: any) => (scope.row.showMore=false)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Minus)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]), [
                        [_vShow, scope.row.showMore && scope.row.systemNames.split('，').length>3]
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "lastLoginTime",
              label: _ctx.$t('login.lastTime'),
              width: "148"
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "date",
              label: _ctx.$t('login.operating'),
              width: getLanguageValue.value==='en'?'190':'170'
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", {
                    class: "operatingBtn pointer",
                    onClick: ($event: any) => (handleDetails(scope.row.id))
                  }, _toDisplayString(_ctx.$t('login.details')), 9, _hoisted_10),
                  (userInfo.value.id !== scope.row.id)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "operatingBtn pointer",
                        onClick: ($event: any) => (resetPass(scope.row.id))
                      }, _toDisplayString(_ctx.$t('login.resetPasswords')), 9, _hoisted_11))
                    : _createCommentVNode("", true),
                  ((isAdmin.value || userInfo.value.userType === 'cs') && !_unref(store).state.simulateToken && userInfo.value.id !== scope.row.id)
                    ? (_openBlock(), _createBlock(_component_el_dropdown, {
                        key: 1,
                        style: {"line-height":"20px"}
                      }, {
                        dropdown: _withCtx(() => [
                          _createVNode(_component_el_dropdown_menu, null, {
                            default: _withCtx(() => [
                              (isAdmin.value && userInfo.value.id !== scope.row.id)
                                ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                    key: 0,
                                    onClick: ($event: any) => (handlePlatformOpen(scope.row))
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('login.platformPermissions')), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (isAdmin.value && userInfo.value.id !== scope.row.id)
                                ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                    key: 1,
                                    onClick: ($event: any) => (handleUnlock(scope.row))
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('login.Unlock')), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (!_unref(store).state.simulateToken)
                                ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                    key: 2,
                                    onClick: ($event: any) => (handleSimulateLogin(scope.row))
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('login.simulateLogin')), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_12, [
                            _createTextVNode(_toDisplayString(_ctx.$t('login.more')) + " ", 1),
                            _createVNode(_component_el_icon, { style: {"transform":"translateY(2px)"} }, {
                              default: _withCtx(() => [
                                _createVNode(_component_arrow_down)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["label", "width"])
          ]),
          _: 1
        }, 8, ["data", "max-height"])), [
          [_directive_loading, _unref(loading)]
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('total', { total: search.total })), 1),
          _createVNode(_component_el_pagination, {
            "current-page": search.pageNo,
            "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((search.pageNo) = $event)),
            "page-size": search.pageSize,
            "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((search.pageSize) = $event)),
            background: "",
            "page-sizes": [100, 200, 300, 400],
            layout: "prev, pager, next, jumper",
            total: search.total,
            onSizeChange: getList,
            onCurrentChange: getList
          }, null, 8, ["current-page", "page-size", "total"])
        ])
      ], 512), [
        [_vShow, !addShow.value]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_17, [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_18, [
          (addShow.value != 'editSysTemAndRole')
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({width:getLanguageValue.value==='en'?'160px':'130px'})
                  }, _toDisplayString(_ctx.$t('login.account')), 5),
                  _createVNode(_component_el_input, {
                    modelValue: form.value.account,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.account) = $event)),
                    class: "w-50 m-2 inputbox",
                    size: "large",
                    placeholder: _ctx.$t('login.input')+_ctx.$t('login.account'),
                    type: "text",
                    disabled: addShow.value == 'details',
                    maxlength: "100",
                    title: form.value.account,
                    onInput: _cache[5] || (_cache[5] = ($event: any) => (form.value.account=form.value.account.replace(/\s/g, '').replace(/[\u4e00-\u9fa5]/g, '')))
                  }, null, 8, ["modelValue", "placeholder", "disabled", "title"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({width:getLanguageValue.value==='en'?'160px':'130px'})
                  }, _toDisplayString(_ctx.$t('login.userName')), 5),
                  _createVNode(_component_el_input, {
                    modelValue: form.value.nickName,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.nickName) = $event)),
                    class: "w-50 m-2 inputbox",
                    size: "large",
                    placeholder: _ctx.$t('login.input')+_ctx.$t('login.userName'),
                    type: "text",
                    disabled: addShow.value == 'details',
                    maxlength: "100",
                    title: form.value.nickName
                  }, null, 8, ["modelValue", "placeholder", "disabled", "title"])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({width:getLanguageValue.value==='en'?'160px':'130px'})
                  }, _toDisplayString(_ctx.$t('login.nickName')), 5),
                  _createVNode(_component_el_input, {
                    modelValue: form.value.userName,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.userName) = $event)),
                    class: "w-50 m-2 inputbox",
                    size: "large",
                    placeholder: _ctx.$t('login.input')+_ctx.$t('login.nickName'),
                    type: "text",
                    disabled: addShow.value == 'details',
                    maxlength: "100",
                    title: form.value.userName
                  }, null, 8, ["modelValue", "placeholder", "disabled", "title"])
                ]),
                (addShow.value != 'details')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("span", {
                        style: _normalizeStyle({width:getLanguageValue.value==='en'?'160px':'130px'})
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('login.password')) + " ", 1),
                        _createVNode(_component_el_tooltip, {
                          content: _ctx.$t('login.passwordStrengthTip'),
                          placement: "top"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_24
                          ]),
                          _: 1
                        }, 8, ["content"])
                      ], 4),
                      _createVNode(_component_el_input, {
                        modelValue: form.value.userPassword,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.userPassword) = $event)),
                        class: "w-50 m-2 inputbox",
                        size: "large",
                        placeholder: _ctx.$t('login.input')+_ctx.$t('login.password'),
                        type: "password",
                        maxlength: "20",
                        "show-password": "",
                        title: form.value.userPassword
                      }, null, 8, ["modelValue", "placeholder", "title"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({width:getLanguageValue.value==='en'?'160px':'130px'})
                  }, _toDisplayString(_ctx.$t('login.userType')), 5),
                  (addShow.value !== 'details')
                    ? (_openBlock(), _createBlock(_component_el_select, {
                        key: 0,
                        modelValue: form.value.userTypeId,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.userTypeId) = $event)),
                        class: "w-50 m-2 inputbox",
                        placeholder: _ctx.$t('login.select')+_unref(t)('login.userType'),
                        size: "large",
                        style: {"margin-top":"1px"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userTypeList.value, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.name,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"]))
                    : (_openBlock(), _createBlock(_component_el_input, {
                        key: 1,
                        modelValue: form.value.userType,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.userType) = $event)),
                        class: "w-50 m-2 inputbox",
                        size: "large",
                        type: "text",
                        maxlength: "100",
                        disabled: "",
                        title: form.value.userType
                      }, null, 8, ["modelValue", "title"]))
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({width:getLanguageValue.value==='en'?'160px':'130px'})
                  }, _toDisplayString(_ctx.$t('login.userEmail')), 5),
                  _createVNode(_component_el_input, {
                    modelValue: form.value.email,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.email) = $event)),
                    class: "w-50 m-2 inputbox",
                    size: "large",
                    placeholder: addShow.value == 'details'?'':_ctx.$t('login.input') + _ctx.$t('login.userEmail'),
                    type: "text",
                    disabled: addShow.value == 'details',
                    maxlength: "100",
                    title: form.value.email
                  }, null, 8, ["modelValue", "placeholder", "disabled", "title"])
                ])
              ]))
            : _createCommentVNode("", true),
          (addShow.value == 'details')
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t('login.relevanceSystem')), 1),
                  _createElementVNode("div", _hoisted_29, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userTable.value, (scope, i) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(scope), 1))
                    }), 256))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])), [
          [_directive_loading, formLoading.value]
        ]),
        _createElementVNode("div", _hoisted_31, [
          (addShow.value != 'details')
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                (!btnLoading.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "btn line pointer",
                      onClick: handleSumbit
                    }, _toDisplayString(_ctx.$t('login.save')), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createTextVNode(_toDisplayString(_ctx.$t('login.save')) + " ", 1),
                      _createVNode(_component_el_icon, {
                        class: "el-icon is-loading",
                        style: {"margin-left":"5px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Loading)
                        ]),
                        _: 1
                      })
                    ]))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "btn pointer",
            onClick: _cache[12] || (_cache[12] = ($event: any) => {addShow.value = false;emits('delLine', 1)})
          }, _toDisplayString(_ctx.$t('login.cancel')), 1)
        ])
      ], 512), [
        [_vShow, addShow.value]
      ])
    ]),
    _createVNode(ResetPasswords, {
      visible: visible.value,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((visible).value = $event)),
      userId: userId.value,
      title: _ctx.$t('login.resetPasswords')
    }, null, 8, ["visible", "userId", "title"]),
    _createVNode(PlatformPer, {
      userId: userId.value,
      open: platFormOpen.value,
      "onUpdate:open": _cache[14] || (_cache[14] = ($event: any) => ((platFormOpen).value = $event)),
      onGetList: getList
    }, null, 8, ["userId", "open"]),
    (simulateLoading.value)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_34, null, 512)), [
          [_directive_loading, simulateLoading.value]
        ])
      : _createCommentVNode("", true)
  ], 64))
}
}

})